import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

interface ISearchElement {
    title: string;
    id: string | number;
}

interface SearchBoxProps {
    elements: ISearchElement[];
    onSelect: (selected: ISearchElement) => void;
    onTextChange?: (text: string) => void;
    placeholder?: string;
}

export default function SearchBox(props: SearchBoxProps) {
    const [inputValue, setInputValue] = React.useState('');
    const [value, setValue] = React.useState<ISearchElement | null>(null);

    return (
        <Autocomplete
            options={props.elements}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.title)}
            isOptionEqualToValue={(opt, val) => typeof opt !== 'string' && typeof val !== 'string' && opt.id === val.id}
            freeSolo
            value={value}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => {
                setInputValue(newInputValue);
                props.onTextChange?.(newInputValue);
            }}
            onChange={(_, newValue) => {
                if (typeof newValue !== 'string' && newValue !== null) {
                    props.onSelect(newValue);
                }
                // Zurücksetzen beider States
                setValue(null);
                setInputValue('');
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Suchen"
                    placeholder={props.placeholder || 'Nach Einträgen suchen...'}
                    size="small"
                    autoComplete="off"
                />
            )}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.title}
                </li>
            )}
            sx={{
                width: '100%',
                '& .MuiAutocomplete-popper': {
                    zIndex: 1500,
                },
            }}
        />
    );
}
